<template>
    <transition
        name="fade"
        mode="out-in"
    >
        <Modal
            v-if="isVisible"
            close-by-click
            @close="$emit('close')"
        >
            <CallbackForm
                v-if="checkWorkTime($CONSTANTS.WORKED_TIME.CALL_CENTER_WORKED_TIME)"
                column
                class="callback-form"
                call-center-label="commonIssues"
                :text="{
                    title: 'Заказ обратного звонка',
                    submitingMessage: `
                        Ваша заявка принята, наши специалисты свяжутся с&nbsp;вами в&nbsp;ближайшее время.
                    `
                }"
            />
            <template v-else>
                <h4 class="h4 text-center">
                    Обратный звонок доступен с {{ workTime.start }} до {{ workTime.end }}
                </h4>
            </template>
        </Modal>
    </transition>
</template>

<script>
import {defineComponent} from 'vue';

import {checkWorkTime} from '@/core/utils/checkWorkTime';
import WORKED_TIME from '@/core/constants/workedTime';
import CallbackForm from '@/components/Forms/CallbackForm.vue';
import Modal from '@/components/UI-components/Modal/UIModal.vue';

export default defineComponent({
    name: 'CallbackModal',
    components: {
        CallbackForm,
        Modal,
    },
    props: {
        isVisible: {
            type: Boolean,
            default: () => false,
        },
    },
    setup() {
        return {
            workTime: {
                start: WORKED_TIME.CALL_CENTER_WORKED_TIME[0],
                end: WORKED_TIME.CALL_CENTER_WORKED_TIME[1],
            },
            checkWorkTime,
        };
    },
});
</script>
